import { useState } from "react";
import { iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
import { getMailboxAccessRequest, MailboxAccessRequest } from "./tenantApiCall";

export function useMailboxAccessRequestsList(
    fetchRequests: () => Promise<iEmsApiResponseBody<getMailboxAccessRequest>>,
) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [requests, setRequests] = useState<Array<MailboxAccessRequest>>([]);

    async function loadData(onLoaded?: (items: Array<MailboxAccessRequest>) => void) {
        setIsLoading(true);
        const response = await fetchRequests();
        if (response.isOk && response.data) {
            setRequests(response.data.items);
            onLoaded?.(response.data.items);
        }
        setIsLoading(false);
    }

    return { isLoading, requests, loadData };
}
